import { WorkerMessage } from "./videoTrimTypes";

export class VideoTrimmerClient {
    private worker: Worker;

    constructor() {
        this.worker = new Worker(
            new URL("./videoTrim.worker.ts", import.meta.url),
            { type: "module" }
        );
    }

    trim(
        file: File,
        startTime: number,
        duration: number,
        onResult?: (file: File) => void,
        onError?: (msg: string) => void
    ) {
        this.worker.onmessage = (event: MessageEvent<WorkerMessage>) => {
            const msg = event.data;

            if (msg.type === "trimResult") {
                onResult?.(msg.file);
            }

            if (msg.type === "error") {
                onError?.(msg.message);
            }
        };

        this.worker.postMessage({
            type: "trim",
            file,
            startTime,
            duration
        });
    }

    trimToBytes(
        file: File,
        startTime: number,
        duration: number,
        onResult?: (images: Uint8Array[]) => void,
        onError?: (msg: string) => void
    ) {
        this.worker.onmessage = (event: MessageEvent<WorkerMessage>) => {
            const msg = event.data;

            if (msg.type === "trimToBytesResult") {
                onResult?.(msg.images);
            }

            if (msg.type === "error") {
                onError?.(msg.message);
            }
        };

        this.worker.postMessage({
            type: "trimToBytes",
            file,
            startTime,
            duration
        });
    }

    terminate() {
        this.worker.postMessage({ type: "terminate" });
        this.worker.terminate();
    }
}
